<div class="flex flex-col w-full h-full bg-gray-100 p-4">
  <div class="bg-white rounded-lg shadow-md p-6 max-h-[calc(100vh-8rem)] overflow-y-auto">
    <h2 class="text-2xl font-bold text-gray-800 mb-6">Retiradas e Suprimentos</h2>

    <!-- Abas -->
    <div class="flex gap-2 mb-4">
      <button
        type="button"
        (click)="setTab('sangrias')"
        [class]="activeTab === 'sangrias' ? 'bg-orange-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'"
        class="px-4 py-2 rounded-lg font-medium transition-colors">
        Sangrias (Retiradas)
      </button>
      <button
        type="button"
        (click)="setTab('suprimentos')"
        [class]="activeTab === 'suprimentos' ? 'bg-orange-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'"
        class="px-4 py-2 rounded-lg font-medium transition-colors">
        Suprimentos
      </button>
    </div>

    <!-- Tabela Sangrias -->
    <div *ngIf="activeTab === 'sangrias'" class="bg-white rounded-md overflow-hidden">
      <p-table
        [value]="sangrias"
        [paginator]="false"
        [loading]="loadingSangrias"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        responsiveLayout="scroll"
        class="min-w-full text-sm">

        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Data/Hora</th>
            <th class="text-left px-6 py-3">Descrição</th>
            <th class="text-left px-6 py-3">Valor</th>
            <th class="text-left px-6 py-3">Espécie</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td class="px-6 py-2">{{ row.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="px-6 py-2">{{ row.description || '-' }}</td>
            <td class="px-6 py-2 font-semibold text-red-600">{{ row.amount | currency:'BRL' }}</td>
            <td class="px-6 py-2">{{ row.specie || '-' }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center py-8 text-gray-500">
              Nenhuma sangria encontrada
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Tabela Suprimentos -->
    <div *ngIf="activeTab === 'suprimentos'" class="bg-white rounded-md overflow-hidden">
      <p-table
        [value]="suprimentos"
        [paginator]="false"
        [loading]="loadingSuprimentos"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-green-50"
        responsiveLayout="scroll"
        class="min-w-full text-sm">

        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Data/Hora</th>
            <th class="text-left px-6 py-3">Descrição</th>
            <th class="text-left px-6 py-3">Valor</th>
            <th class="text-left px-6 py-3">Espécie</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td class="px-6 py-2">{{ row.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="px-6 py-2">{{ row.description || '-' }}</td>
            <td class="px-6 py-2 font-semibold text-green-600">{{ row.amount | currency:'BRL' }}</td>
            <td class="px-6 py-2">{{ row.species || '-' }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center py-8 text-gray-500">
              Nenhum suprimento encontrado
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Botão Voltar -->
    <div class="flex justify-end mt-4">
      <button
        (click)="goBack()"
        pButton
        type="button"
        label="ESC - Voltar"
        class="p-button-secondary">
      </button>
    </div>
  </div>
</div>
